<template>
  <div>
    <div class="row sticky-button">
      <div class="col-12 col-sm-7 col-md-5 col-lg-5 px-0">
        <div class="form-group has-label">
          <minus-plus
            :label="`${$t('common_words.sub_categories_num')}: *`"
            @handlePlus="handlePlus"
            @handleMinus="handleMinus"
            :value="model.subcategory_number"
          />
        </div>
      </div>
    </div>
    <div
      class="row py-3 mb-4 shadow-sm"
      style="border: 0.5px solid #6ba6524d"
      v-for="index in model.subcategory_number"
      :key="index"
    >
      <div class="col-12 col-md-4 col-xl-4">
        <fg-input
          :label="`${$t('common_words.sub_category_num')} ${index}: *`"
          class="required-name pl-0"
          ref="name"
          type="text"
          v-model="model.name_sub[index - 1]"
          name="common_words.sub_category_num"
          v-validate="modelValidations.name_sub"
          :error="getError('common_words.sub_category_num', true, index)"
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-2">
        <fg-input
          :label="`${$t('common_words.code')}: *`"
          class="required-code"
          ref="code"
          type="text"
          v-model="model.code_sub[index - 1]"
          name="common_words.code_of_row"
          v-validate="modelValidations.code_sub"
          :error="getError('common_words.code_of_row', true, index)"
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-2">
        <fg-input
          :label="`${$t('common_words.description')}: *`"
          class="required-description"
          v-model="model.description_sub[index - 1]"
          name="common_words.description"
          v-validate="modelValidations.description_sub"
          :error="getError('common_words.description', true, index)"
          placeholder="..."
          maxlength="200"
          show-word-limit
          type="textarea"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-xl-2">
        <div class="form-group has-label">
          <label>{{ $t('common_words.status') }}</label>
          <el-switch
            v-model="model.enable[index - 1]"
            style="display: block; margin-top: 0.5rem"
            active-color="#6BA652"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { MixinExport } from 'src/mixins/mixin-export';
import { Switch } from 'element-ui';
import { Tooltip } from 'element-ui';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  components: {
    [Switch.name]: Switch,
    [Tooltip.name]: Tooltip,
    [MinusPlus.name]: MinusPlus,
  },

  data() {
    return {
      model: {
        id_sub: [],
        name_sub: [],
        code_sub: [],
        description_sub: [],
        enable: [true],
        subcategory_number: 1,
      },
      modelValidations: {
        name_sub: {
          required: true,
        },
        code_sub: {
          required: true,
        },
        description_sub: {
          required: true,
        },
        subcategory_number: {
          required: true,
          min_value: 0,
        },
      },
      enable: [],
      map: null,
    };
  },
  mixins: [MixinPermissions, MixinMasters, MixinExport, MixinForm],

  methods: {
    handlePlus() {
      this.model.subcategory_number++;
      this.handleNumberChange();
    },

    handleMinus() {
      const minNumber = this.getNumberSubCategories() || 1;
      if (this.model.subcategory_number > minNumber) {
        this.model.subcategory_number--;
        this.handleNumberChange();
      }
    },

    getNumberSubCategories() {
      let value = this.model.id_sub.length;

      return value;
    },

    handleNumberChange() {
      let codes = [...this.model.code_sub];
      let names = [...this.model.name_sub];
      let descriptions = [...this.model.description_sub];
      let actEnables = [...this.model.enable];
      for (let i = 0; i <= this.model.subcategory_number - 1; i++) {
        actEnables.push(true);
      }
      this.model.enable = actEnables;
      if (
        this.model.name_sub.length > 0 &&
        this.model.name_sub.length > this.model.subcategory_number
      ) {
        this.$set(
          this.model,
          'code_sub',
          codes.splice(0, this.model.subcategory_number)
        );
        this.$set(
          this.model,
          'name_sub',
          names.splice(0, this.model.subcategory_number)
        );
        this.$set(
          this.model,
          'description_sub',
          descriptions.splice(0, this.model.subcategory_number)
        );
      }
    },

    opty(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);
        this.$emit('fillCategoriesForm', 'secondStep', this.model);
        return res;
      });
    },

    // validate() {
    //   return this.$validator
    //     .validateAll()
    //     .then((res) => {
    //       this.$emit('on-validated', res, this.model);
    //       this.$emit('fillActivitiesGroupForm', 'secondStep', {
    //         payment_unit_names: this.opty(
    //           this.model.payment_unit,
    //           this.activityUnit
    //         ),
    //         production_unit_names: this.opty(
    //           this.model.production_unit,
    //           this.activityUnit
    //         ),
    //       });
    //       return res;
    //     })
    //     .then((resp) => {
    //       if (!resp) return resp;
    //       if (!isset(this.model.catchType)) {
    //         return this.validationInputsRequired('catchType');
    //       } else if (!isset(this.model.payment_unit)) {
    //         return this.validationInputsRequired('unitPayment');
    //       } else if (!isset(this.model.production_unit)) {
    //         return this.validationInputsRequired('unitProduction');
    //       } else {
    //         return true;
    //       }
    //     });
    // },

    // validateMinimum(index) {
    //   if (
    //     Number(this.model.minimum[index]) >= Number(this.model.maximum[index])
    //   ) {
    //     let minumums = [...this.model.minimum];
    //     minumums[index] = '';
    //     this.$set(this.model, 'minimum', minumums);
    //   }
    // },
  },

  // created() {
  //   if (this.isCreate() || this.isUpdate()) {
  //     Axios.getMasters('works/activityunits/field')
  //       .then((response) => {
  //         this.activityUnit = response.data.data;
  //         this.showHideLoading();
  //       })
  //       .catch((error) => this.showMessageErrors(error));
  //   } else this.showHideLoading();
  // },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      this.model.enable = [];
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.subcategory_number = editForm.categories.length;
      editForm.categories.forEach((element) => {
        this.model.id_sub.push(element.id);
        this.model.name_sub.push(element.name);
        this.model.code_sub.push(element.code);
        this.model.description_sub.push(element.description);
        if (element.deleted_at) {
          this.model.enable.push(false);
        } else {
          this.model.enable.push(true);
        }
      });
    }
  },

  destroyed() {
    localStorage.removeItem('listFiles');
  },
};
</script>
